// -------------------------------声明-------------------------------------------
// <auto-generated>
//     此文件是自动生成的文件，对这个文件的任何修改在下次自动生成的时候都会丢失。
//     模板名称：\TTFiles\TS\Entity\EnumType.tt
// </auto-generated>
// ------------------------------------------------------------------------------
import { EnumItemMD } from '../../../../../../libs/com/MetaPattern/MDA/MD/EnumItemMD';

/**
 * 设置应用枚举 枚举类
 * 设置应用枚举，定义设置项可应用的范围
 */
export enum EnumSettingApply {
  /** 全局 : 全局 */
  Global = 1,
  /** 产品 : 产品 */
  Product = 2,
  /** 应用 : 应用 */
  APP = 4,
  /** 产品引用应用 : 产品引用应用 */
  ProductAPP = 8
}

/**
 * 设置应用枚举 枚举元数据类
 * 获取枚举的元数据信息：名称、显示名称、描述、值
 */
export class EnumSettingApplyMD {
  private static items = [
    new EnumItemMD('Global', 1, '全局', '全局'),
    new EnumItemMD('Product', 2, '产品', '产品'),
    new EnumItemMD('APP', 4, '应用', '应用'),
    new EnumItemMD('ProductAPP', 8, '产品引用应用', '产品引用应用')
  ];

  static getItem(enumItem: EnumSettingApply) {
    return this.items.find(item => item.name === EnumSettingApply[enumItem]);
  }

  static getItemByName(enumItemName: string) {
    return this.items.find(item => item.name === enumItemName);
  }

  static getItemByValue(enumItemValue: number) {
    return this.items.find(item => item.value === enumItemValue);
  }

  static getItems() {
    return this.items;
  }
}
